import React from 'react';
import styled from 'styled-components';
import Theme from '../../../Theme';
import * as AppActions from '../../../AppActions';
import {useOutlet, useOutletSetter} from 'reconnect.js';
import ListSection from '../ListSection';
import CarouselSection from '../CarouselSection';
import Calendar from '../../../Components/Calendar/landing';
import * as Ant from 'antd';
import * as User from 'rev.sdk.js/Actions/User';

function Landing(props) {
  const [_landing] = useOutlet('landing');
  const {
    pageContext: {prebuiltSiteConfig},
  } = props;

  const landing = _landing || prebuiltSiteConfig.landing || {};
  const {carousel = [{}], bottom_links = []} = landing.custom_layout || {};

  return (
    <Wrapper>
      <div className="main">
        <CarouselSection
          className="carousel"
          items={carousel
            .filter((c) => c.doctor_area)
            .sort((a, b) => a.order - b.order)}
        />

        <section className="right">
          <LoginSection />
          <div style={{height: 10}} />
          <Calendar
            setSelectedDt={(value) => {
              console.log('onClick date', value);
              if (value instanceof Date) {
                const date = value.toLocaleDateString('sv');
                AppActions.navigate('/doctor/events/events?date=' + date);
              }
            }}
          />
        </section>

        <ListSection
          className="list-1"
          title="最新消息"
          route="/doctor/news"
          collection="Article_Default"
          color="#b3629d"
          isNews={true}
        />
        <ListSection
          className="list-2"
          title="課程活動"
          route="/doctor/events/events"
          itemRoute="/doctor/events/content"
          collection="product"
          color="#557ad2"
        />
        <ListSection
          className="list-3-1"
          title="福利活動"
          route="/doctor/events/events"
          itemRoute="/doctor/events/content"
          collection="product"
          category="福利活動"
          color="#62923d"
        />
        <ListSection
          className="list-3-2"
          title="社福活動消息"
          route="/doctor/news"
          collection="Article_Default"
          color="#f59000"
          category="社福團體活動公告"
          isNews={true}
        />
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-top: var(--topNavBarHeight);
  min-height: var(--contentMinHeight);
  background-color: var(--primaryBgcolor);

  & > .main {
    max-width: var(--contentMaxWidth);
    margin: 0px auto;
    padding: 40px 0;

    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: repeat(7, auto-fit);
    row-gap: 20px;
    column-gap: 40px;

    & > section.carousel {
      grid-column: span 2;
      grid-row: span 3;
    }
    & > section.right {
      grid-column: 3;
      grid-row: span 3;
    }

    & > section.list-1 {
      grid-column: 1;
      grid-row: 4 / 8;
    }
    & > section.list-2 {
      grid-column: 2;
      grid-row: 4 / 8;
    }
    & > section.list-3-1 {
      grid-column: 3;
      grid-row: 4;
    }
    & > section.list-3-2 {
      grid-column: 3;
      grid-row: 5 / 8;
    }
  }

  @media (max-width: ${Theme.maxWidth}px) {
    & > .main {
      padding: 20px;
    }
  }

  @media (max-width: ${Theme.breakpoint}px) {
    & > .main {
      grid-template-columns: 1fr;
      & > section.carousel {
        grid-column: span 1;
        grid-row: 1;
      }
      & > section.right {
        grid-column: span 1;
        grid-row: 2;
      }
      & > section.list-1 {
        grid-column: span 1;
        grid-row: 3;
      }
      & > section.list-2 {
        grid-column: span 1;
        grid-row: 4;
      }
      & > section.list-3-1 {
        grid-column: span 1;
        grid-row: 5;
      }
      & > section.list-3-2 {
        grid-column: span 1;
        grid-row: 6;
      }
    }
  }
`;

function LoginSection({}) {
  const [user] = useOutlet('user');
  const showLoginModal = useOutletSetter('login-modal');

  return (
    <LoginSectionWrapper>
      <div className="header">
        <h2>{user ? `Hi, ${user.data?.name}` : '會員登入'}</h2>
      </div>
      {user ? (
        <div className="row">
          <div style={{flex: 1}}>歡迎您回來</div>
          <Ant.Button
            onClick={async () => {
              AppActions.setLoading(true);
              User.logout();
              await AppActions.delay(500);
              AppActions.setLoading(false);
              AppActions.navigate('/doctor');
            }}>
            登出
          </Ant.Button>
        </div>
      ) : (
        <div className="row">
          <div style={{flex: 1}}>您尚未登入</div>
          <Ant.Button onClick={() => showLoginModal(true)}>登入</Ant.Button>
        </div>
      )}
    </LoginSectionWrapper>
  );
}

const LoginSectionWrapper = styled.div`
  padding: 15px 20px;
  background-color: var(--primaryColor);
  border-radius: 6px;
  color: white;

  .header {
    display: flex;
    align-items: center;

    & > h2 {
      color: white;
    }
  }

  .row {
    display: flex;
    align-items: center;
  }
`;

export default Landing;
